import {EventData} from '@/types/event';
import EventCard from './event-card';
import {Button, Grid, Typography} from '@mui/material';
import EventCreateButton from '@/components/groups/details/buttons/big-create-button';
import {useTranslation} from 'react-i18next';
import MatrixUnreadEventsProvider from '@/contexts/matrix/unread-events/provider';

const EVENT_CARD_HEIGHT = '80';

type EventListProps = {
  events: Array<EventData>;
  onEventCardClick: (event: EventData) => void;
  eventsCreatingAllowed: boolean;
  handleCreateButtonClicked: () => void;
  handleOpenAllEventsDialog: () => void;
  smallerVariant?: boolean;
  trainerInSjOneNoManager?: boolean;
};

const EventList: React.FC<EventListProps> = ({
  events,
  onEventCardClick,
  eventsCreatingAllowed,
  handleCreateButtonClicked,
  handleOpenAllEventsDialog,
  smallerVariant = false,
  trainerInSjOneNoManager
}) => {
  const {t} = useTranslation();

  return (
    <>
      {!trainerInSjOneNoManager && (
        <Grid item xs={12} md={12}>
          <EventCreateButton
            onClick={handleCreateButtonClicked}
            isDisabled={!eventsCreatingAllowed}
          />
        </Grid>
      )}

      {events.slice(0, 3).map((event) => {
        return (
          <Grid item xs={12} md={12} key={event._id}>
            <MatrixUnreadEventsProvider documentId={event._id}>
              <EventCard
                event={event}
                onEventCardClick={onEventCardClick}
                fullWidth={true}
                cardMediaHeight={EVENT_CARD_HEIGHT}
                cardMediaTypography="h6"
                customTitleWidth="16ch"
                alwaysTruncate={true}
                smallerVariant={smallerVariant}
              />
            </MatrixUnreadEventsProvider>
          </Grid>
        );
      })}
      {events.length > 3 && (
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Button onClick={handleOpenAllEventsDialog}>
            <Typography variant="h6">{t('see_all_events')}</Typography>
          </Button>
        </Grid>
      )}
    </>
  );
};
export default EventList;
